import {useCallback} from 'react'
import {useLocation} from 'react-router-dom'

import type {ProjectOrBuildTypeNode} from '../../../../types'
import {stringifyId} from '../../../../types'
import {queryToObject} from '../../../../utils/queryParams'
import {useChangeProblemsFilter} from '../../../packages/Problems/Problems.hooks'

export const useProjectIdFilter = () => {
  const location = useLocation()
  const {projectId} = queryToObject(location.search)
  const onFilterChange = useChangeProblemsFilter()
  const onProjectChange = useCallback(
    (data: ProjectOrBuildTypeNode | null | undefined) => {
      if (data?.nodeType === 'project') {
        onFilterChange({projectId: stringifyId(data?.id) || undefined})
      } else {
        onFilterChange({projectId: undefined})
      }
    },
    [onFilterChange],
  )
  return {
    projectId,
    onProjectChange,
  }
}
